import React, { useState, useCallback, useContext, useEffect } from "react";

import ICalFeedsToImportTable from "components/PageDashboard/ICalFeedsToImportSection/ICalFeedsToImportTable";
import { DashboardContext } from "components/PageDashboard/PageDashboard";
import { useRemoteResource } from "hooks/useRemoteResource";
import { useSendData } from "hooks/useSendData";
import { SearchResults } from "types-and-validators/SearchResults";
import { saveICalFeedsToImport as sst } from "api/saveICalFeedsToImport";
import {
	getICalFeedsToImport,
	OutputRow as ICalFeedsToImportData
} from "api/getICalFeedsToImport";
import { AuthContext } from "components/AuthProvider/AuthProvider";
import { useOnEditEditableTable } from "hooks/useOnEditEditableTable";

const ICalFeedsToImportSection: React.FunctionComponent = () => {
	const [{ isSignedIn, uid }] = useContext(AuthContext);

	const [, setDashboardContextState] = useContext(DashboardContext);

	const fetchICalFeedsToImport = useCallback(() => {
		if (!uid) {
			throw new Error("No uid");
		}
		return getICalFeedsToImport(
			{
				uid
			},
			{ uid }
		);
	}, [uid]);

	const doWait = isSignedIn === undefined || !uid;

	const [fetchIterationNumber, setFetchIterationNumber] = useState(1);

	const {
		isWaiting,
		isLoading,
		isError,
		output: iCalFeedsToImport
	} = useRemoteResource<SearchResults<ICalFeedsToImportData>>(
		fetchICalFeedsToImport,
		doWait,
		fetchIterationNumber,
		true
	);

	const [waitModalIsShowing, setWaitModalIsShowing] = useState(false);
	const [waitModalTitle, setWaitModalTitle] = useState("");
	const saveICalFeedsToImport = useSendData({ method: sst });

	const haveICalFeedsToImport =
		iCalFeedsToImport === undefined
			? undefined
			: iCalFeedsToImport.page.length !== 0;

	useEffect(() => {
		setDashboardContextState(oldState => ({
			...oldState,
			haveICalFeedsToImport
		}));
	}, [haveICalFeedsToImport, setDashboardContextState]);

	const onEditICalFeedsToImport = useOnEditEditableTable({
		setWaitModalIsShowing,
		setWaitModalTitle,
		dataSaver: saveICalFeedsToImport,
		onSaved: setFetchIterationNumber
	});

	// TODO:WV:20201009:Get the user started, maybe by asking for price during onboarding and / or adding a tutorial / walkthrough of how to set them up
	return (
		<ICalFeedsToImportTable
			onEdit={onEditICalFeedsToImport}
			iCalFeedsToImport={iCalFeedsToImport ? iCalFeedsToImport.page : []}
			isLoading={isLoading}
			isWaiting={isWaiting || !iCalFeedsToImport}
			isError={isError}
			waitModalTitle={waitModalTitle}
			waitModalIsShowing={waitModalIsShowing}
		/>
	);
};

export default ICalFeedsToImportSection;
